import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import purchaseOrderConfig from './config/purchaseOrderConfig';
import setViewTitle from '../../helpers/setViewTitle';
import Widget from '../common/Widget';
import CommentsWidget from '../common/CommentsWidget';
import DocumentsCollection from '../common/DocumentsCollection';
import NeedsClaim from '../common/NeedsClaim';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var OrderedPurchaseOrder = createReactClass({

  getInitialState() {
    return {
      hasBeenFound: false,
      order: {
        lines: [],
        newLines: [],
      }
    };
  },

  componentWillMount() {
    setViewTitle('Offene Bestellungen');
  },

  componentDidMount() {
    request.get({
      url: purchaseOrderConfig.apiUrl + 'ordered/' + this.props.match.params.id,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            hasBeenFound: true,
            order: data
          });
        }
      }
    });
  },

  handleSubmitForPrepared(e) {
    e.preventDefault();
    this.props.history.push(`/shipments/prepared/${this.props.match.params.id}`);
  },

  handleSubmitForNew(e) {
    e.preventDefault();
    this.props.history.push(`/shipments/new/${this.props.match.params.id}`);
  },

  enrichNewComment(newComment) {
    newComment.orderId = this.state.order.id;
    return newComment;
  },

  onDocumentDeleted(document) {
    const order = this.state.order;
    const documentIndexToDelete = order.documents.findIndex(x => x.id === document.id);

    if (documentIndexToDelete >= 0) {
      order.documents.splice(documentIndexToDelete, 1);
      this.setState({order});
    }
  },

  onDocumentUploaded(document) {
    const order = this.state.order;
    order.documents.push(document);
    this.setState({order});
  },

  render() {
    if (!this.state.hasBeenFound) {
      return null;
    }

    var displayLines = this.state.order.lines.map((line, index) =>
      <tr key={'line' + index}>
        <td>{line.itemName}</td>
        <td>{line.purchaseUnitQuantity}</td>
        <td>{line.purchaseUnitName}</td>
        <td>{line.lineNetPrice}</td>
      </tr>
    );

    var displayNewLines = this.state.order.newLines.map((line, index) =>
      <tr key={'newLine' + index}>
        <td>{line.itemName}</td>
        <td>{line.purchaseUnitQuantity}</td>
        <td>{line.purchaseUnitName}</td>
        <td>{line.lineNetPrice}</td>
      </tr>
    );

    var hasBeenPrepared = (this.state.order.shipment != null) && (this.state.order.shipment.isShipmentComplete);

    const checkBoxStyles = {
      marginLeft: '8px',
      marginTop: '10px',
      marginBottom: '10px',
      width: '200px'
    };

    return (
      <div>
        <div className="row">
          <Widget title="Bestellungsübersicht">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Artikel</th>
                    <th>Bestellmenge</th>
                    <th>Bestelleinheit</th>
                    <th>Preis</th>
                  </tr>
                </thead>
                <tbody>
                    {displayLines}
                    {displayNewLines}
                </tbody>
              </table>
            </div>

            <div className="widget-footer">
              {this.state.order.orderWithoutStorage &&
                <form className="smart-form">
                  <label className="checkbox" style={checkBoxStyles}>
                    Bestellung ohne Lagerführung
                    <input
                      type="checkbox"
                      name="checkbox-inline"
                      defaultChecked={true}
                      disabled
                    />
                    <i></i>
                  </label>
                </form>
              }
              <NeedsClaim claim="purchaseorders:newshipment">
                <input type="button" className="btn btn-primary" value="Wareneingang erfassen" disabled={this.props.isAjaxInProgress || hasBeenPrepared} onClick={this.handleSubmitForNew}/>
              </NeedsClaim>
              {!this.state.order.orderWithoutStorage &&
                <NeedsClaim claim="purchaseorders:newreceipt">
                  <input type="button" className="btn btn-primary" value="Rechnung erfassen" disabled={this.props.isAjaxInProgress || !hasBeenPrepared} onClick={this.handleSubmitForPrepared}/>
                </NeedsClaim>
              }
            </div>

          </Widget>
        </div>
        <div className="row">
          <CommentsWidget
            apiUrl={`purchaseorders/${this.state.order.id}/comments`}
            containerClassName="col-md-12"
            beforeSubmit={newComment => this.enrichNewComment(newComment)}
            claim="purchaseorders:write"
          />
        </div>
        <div className="row">
          <DocumentsCollection
            documents={this.state.order.documents}
            onDoumentDeleted={this.onDocumentDeleted}
            onDocumentUploaded={this.onDocumentUploaded}
            deleteUrlBase={`${purchaseOrderConfig.apiUrl}${this.state.order.id}`}
            viewUrlBase={`${purchaseOrderConfig.apiUrl}${this.state.order.id}`}
            uploadUrlBase={`${purchaseOrderConfig.apiUrl}${this.state.order.id}`}
            claim="purchaseorders:write"
          />
        </div>
      </div>
    );
  }

});

export default AjaxInProgressHOC(OrderedPurchaseOrder);



// WEBPACK FOOTER //
// ./src/components/purchaseorders/OrderedPurchaseOrder.js